import { App } from './app.class';
import { Modal } from './modal.class';
import { Notification } from './notification.class';
import { Fetch } from '../fetch.class';
import { Popup } from './popup.class';
import ClipboardJS from 'clipboard';
import * as Sqrl from 'squirrelly';

export class Page {

    constructor() {

        // Text Datenschutzerklärung ---------------------

        // HTML-Code kopieren
        const $btnCopyHtml = document.querySelector('.copy-html');
        const htmlClipboard = new ClipboardJS($btnCopyHtml, {
            text: function(trigger) {
                const $privacy_text = document.querySelector(".privacy-terms-text");
                let code = $privacy_text.innerHTML.trim();
                return code;
            }
        });
        htmlClipboard.on('success', event => {
            event.clearSelection();
            const msg = event.trigger.dataset.successmsg ?? "Copied!";
            new Notification().success(msg);
        });

        // Text kopieren
        const $btnCopyText = document.querySelector('.copy-text');
        const textClipboard = new ClipboardJS($btnCopyText, {
            text: function(trigger) {
                const $privacy_text = document.querySelector(".privacy-terms-text");
                let text = $privacy_text.textContent.trim();
                return text;
            }
        });
        textClipboard.on('success', event => {
            event.clearSelection();
            const msg = event.trigger.dataset.successmsg ?? "Copied!";
            new Notification().success(msg);
        });


        // AV-Vertrag ---------------------

        // Template für AV-Anzeige
        this.tplAv = Sqrl.compile( document.getElementById('tpl_av').innerHTML.replace(/=&gt;/g, '=>') );

        // Elemente
        this.areaLoading = document.querySelector('#area-loading');
        this.areaDisplayAv = document.querySelector('#area-display-av');
        this.areaCreateAv = document.querySelector('#area-create-av');

        this.btnsCreateAv = document.querySelectorAll('button.create-av');
        this.$errorboxCreateAv = document.querySelector('#modal-create-av .errorbox');
        this.$textareaAuftraggeber = document.querySelector('#modal-create-av #auftraggeber');
        this.$textareaAnsprechpartner = document.querySelector('#modal-create-av #ansprechpartner');
        this.$formCreateAv = document.querySelector('#modal-create-av form');

        // Vertrag laden
        this.loadAvContract();

        // Modal
        this.modalCreateAv = new Modal('#modal-create-av');

        // Modaldialog öffnen
        this.btnsCreateAv.forEach($btn => {
            $btn.addEventListener('click', event => {

                // Fehlermeldung ausblenden
                this.$errorboxCreateAv.classList.add('hidden');

                // Modal öffnen
                this.modalCreateAv.show();
            });
        });

        // Zeilenanzahl der Textareas begrenzen
        this.$textareaAuftraggeber.addEventListener('input', event => {
            const textarea = event.target;
            const maxRows = parseInt(textarea.getAttribute("rows"), 10);
            if (!maxRows || isNaN(maxRows)) return;
            const lines = textarea.value.split("\n");
            if (lines.length > maxRows) {
                textarea.value = lines.slice(0, maxRows).join("\n");
            }
        });
        this.$textareaAnsprechpartner.addEventListener('input', event => {
            const textarea = event.target;
            const maxRows = parseInt(textarea.getAttribute("rows"), 10);
            if (!maxRows || isNaN(maxRows)) return;
            const lines = textarea.value.split("\n");
            if (lines.length > maxRows) {
                textarea.value = lines.slice(0, maxRows).join("\n");
            }
        });

        // Vertrag erstellen
        this.$formCreateAv.addEventListener('submit', event => {
            event.preventDefault();

            const data = new FormData();
            data.append("auftraggeber", this.$textareaAuftraggeber.value);
            data.append("ansprechpartner", this.$textareaAnsprechpartner.value);

            // Fehler ausblenden
            this.$errorboxCreateAv.classList.add('hidden');

            // Senden
            new Fetch().post(App.getUrl('privacy', 'create_av'), data)
            .then(response => {

                // Modal schliessen
                this.modalCreateAv.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // Anzeige aktualisieren
                this.loadAvContract();
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxCreateAv.querySelector('.cont').textContent = error.message;
                this.$errorboxCreateAv.classList.remove('hidden');
            });
        });
    }

    // Av-Vertrag laden
    loadAvContract() {

        // Ladespinner anzeigen
        this.areaDisplayAv.classList.add("hidden");
        this.areaCreateAv.classList.add("hidden");
        this.areaLoading.classList.remove("hidden");

        // Daten abrufen
        new Fetch().get(App.getUrl('privacy', 'load_av'))
        .then(response => {

            // kein Vertrag vorhanden
            if(response.av_available == false) {
                this.areaDisplayAv.classList.add("hidden");
                this.areaCreateAv.classList.remove("hidden");
            }

            // Vertrag vorhanden
            else {

                // Inhalt aus Template erstellen
                this.areaDisplayAv.querySelector(".template-area").innerHTML = this.tplAv(response, Sqrl.defaultConfig);
                this.areaDisplayAv.classList.remove("hidden");
            }
        })
        .catch(error => {

            // Fehlermeldung anzeigen
            new Notification().error(error.message);
        })
        .finally(() => {

            // Ladespinner ausblenden
            this.areaLoading.classList.add("hidden");
        });

    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('privacy')) {
        new Page();
    }
});